module.exports = __webpack_public_path__ + "static/media/RectangleBlue.213478be.svg";